// Reusable Logo component
import React from 'react';

function Logo({ size = 'md', className = '' }) {
  const sizeClasses = {
    sm: 'h-5 w-5',
    md: 'h-6 w-6',
    lg: 'h-10 w-10',
    xl: 'h-12 w-12',
  };

  return (
    <img 
      src="/logo.png" 
      alt="FollowUP Logo" 
      className={`${sizeClasses[size]} object-contain ${className}`}
      onError={(e) => {
        // Hide logo if image doesn't exist
        e.target.style.display = 'none';
      }}
    />
  );
}

export default Logo;

